import { DraftPick } from '../../Api/Draft/draft.types'
import { teamsDataArray } from '../../Constants/team'

export const draftedByPLL = (picks: DraftPick[]) => {
  const officialTeamIdsSet = new Set(teamsDataArray.map((team) => team.officialId))
  const filtered = picks.filter(
    (p) => officialTeamIdsSet.has(p.teamId) && p.teamId !== 'ZPP'
  )
  return filtered
}
